import { render, staticRenderFns } from "./CataractOpacity.vue?vue&type=template&id=06c84079&scoped=true&"
import script from "./CataractOpacity.vue?vue&type=script&lang=js&"
export * from "./CataractOpacity.vue?vue&type=script&lang=js&"
import style0 from "./CataractOpacity.vue?vue&type=style&index=0&id=06c84079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c84079",
  null
  
)

export default component.exports